import React from 'react';

const AWS_ECS = () => {
  return (
    <div>
      <h1>AWS_ECS</h1>
      <p>This is the AWS_ECS component.</p>
    </div>
  );
};

export default AWS_ECS;
